import React from "react";
import CloseIcon from "@mui/icons-material/Close";

import { ErrorMessage, PrimaryButton, Table } from "widgets";
import Loader from "shared/Loader/Loader";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import {
  useFetchInvoiceDetails,
  useFetchPaymentTaxInvoice,
} from "store/backend/assets";

import styles from "./DownloadInvoice.module.scss";
import { INVOICE_DETAILS_COLUMN } from "constants/constants";
const handleOnClickDownloadInvoice = (
  invoiceNumber,
  fetchPaymentTaxInvoice,
  openSnackbar
) => {
  if (!invoiceNumber) {
    openSnackbar(
      "No invoice number provided",
      "error"
    );
    return;
  }

  fetchPaymentTaxInvoice(invoiceNumber)
    .then((response) => {
      const link = document.createElement("a");
      link.href = response.signedUrl;
      link.click();
      openSnackbar("Payment tax invoice downloaded successfully!", "success");
    })
    .catch((error) => {
      openSnackbar(
        error.message || "Error fetching payment tax invoice",
        "error"
      );
    });
};

const getInvoiceDetails = (
  invoiceDetails,
  fetchPaymentTaxInvoice,
  isFetchingPaymentTaxInvoice,
  openSnackbar
) => {
  return invoiceDetails.map((invoice) => ({
    billingEntity: invoice.billing_entity,
    invoiceNumber: invoice.invoice_number,
    invoiceDate: invoice.invoice_generation_date,
    amount: invoice.invoice_amount,
    download: (
      <PrimaryButton
        onClick={() =>
          handleOnClickDownloadInvoice(
            invoice.invoice_number,
            fetchPaymentTaxInvoice,
            openSnackbar
          )
        }
      >
        {isFetchingPaymentTaxInvoice ? (
          <Loader fullscreen={false} />
        ) : (
          "Download"
        )}
      </PrimaryButton>
    ),
  }));
};

const DownloadInvoice = ({ onClose, paymentId }) => {
  const { openSnackbar } = useSnackbarContext();
  const {
    data: invoiceDetails,
    isPending: isInvoiceDetailsLoading,
    isError: isErrorOnInvoiceDetails,
    error: errorMessageOnInvoiceDetails,
  } = useFetchInvoiceDetails(paymentId);

  const { fetchPaymentTaxInvoice, isLoading: isFetchingPaymentTaxInvoice } =
    useFetchPaymentTaxInvoice();

  if (isErrorOnInvoiceDetails)
    return <ErrorMessage>{errorMessageOnInvoiceDetails.message}</ErrorMessage>;

  const invoiceDetailsRows = invoiceDetails
    ? getInvoiceDetails(
        invoiceDetails,
        fetchPaymentTaxInvoice,
        isFetchingPaymentTaxInvoice,
        openSnackbar
      )
    : [];

  return (
    <div className={styles.downloadInvoiceContainer}>
      {isInvoiceDetailsLoading ? (
        <Loader />
      ) : (
        <>
          <div className={styles.header}>
            <CloseIcon
              className={styles.closeIcon}
              onClick={onClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className={styles.title}>Download Invoice</div>
          <div className={styles.horizontalLine} />
          <Table columns={INVOICE_DETAILS_COLUMN} rows={invoiceDetailsRows} />
        </>
      )}
    </div>
  );
};

export default DownloadInvoice;
